import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function MSPPTIcon({ className, fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? IconColors.Orange} fillRule="evenodd">
        <path d="M16.65 9.75v6.75c0 .414.336.75.75.75.415 0 .75-.336.75-.75V9.75h.75c.415 0 .75-.336.75-.75s-.335-.75-.75-.75h-3c-.414 0-.75.336-.75.75s.336.75.75.75h.75zm-6.397 3.82v2.93c0 .414.336.75.75.75s.75-.336.75-.75v-2.248c1.655-.002 2.997-1.344 2.997-3 0-1.657-1.343-3-3-3h-.692l-.055-.002c-.154 0-.298.047-.417.127-.202.134-.336.364-.336.625 0 .023.001.045.003.068v4.364c-.002.023-.003.045-.003.068 0 .023.001.045.003.068zm1.5-3.818c.827.002 1.497.673 1.497 1.5s-.67 1.498-1.497 1.5v-3zM4.744 13.57v2.93c0 .414.336.75.75.75s.75-.336.75-.75v-2.248c1.656-.002 2.997-1.344 2.997-3 0-1.657-1.343-3-3-3H5.55l-.055-.002c-.154 0-.298.047-.417.127-.202.134-.336.364-.336.625 0 .023.001.045.003.068v4.364c-.002.023-.003.045-.003.068 0 .023.001.045.003.068zm1.5-3.818c.827.002 1.497.673 1.497 1.5s-.67 1.498-1.497 1.5v-3zm15.381 11.185c0 .76-.616 1.375-1.375 1.375H3.75c-.76 0-1.375-.615-1.375-1.375V3.063c0-.759.616-1.374 1.375-1.374h13.791c.36 0 .704.14.96.39l2.709 2.643c.265.259.415.614.415.984v15.233z" />
      </g>
    </SimpleIcon>
  );
}
